var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalPolicyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 142,
    viewBox: "0 0 130 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#medical_policy_filled_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 48,
    height: 60,
    rx: 5,
    fill: "#005FF9",
    stroke: "#005FF9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 55,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 61,
    width: 16.917,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 67,
    width: 11.518,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.653 33.178a4.378 4.378 0 00-6.187 0l-5.12 5.12a4.378 4.378 0 000 6.187 4.378 4.378 0 006.188 0l5.12-5.12a4.378 4.378 0 000-6.187zm-8.04 4.328a.897.897 0 01.7-.26c.523.087 1.431.312 2.196 1.076.769.769.986 1.688 1.046 2.216a.877.877 0 01-.255.675c-.431.462-1.3 1.331-1.3 1.331l-.704.704a2.626 2.626 0 01-3.712-3.713l1.213-1.212.816-.817z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "medical_policy_filled_svg__filter0_d",
    x: 0,
    y: 0,
    width: 130,
    height: 142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgMedicalPolicyFilled as ReactComponent };